import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-fb-redirect-popup',
  templateUrl: './fb-redirect-popup.component.html',
  styleUrls: ['./fb-redirect-popup.component.scss']
})
export class FbRedirectPopupComponent implements OnInit {
  @Output() confirmAction = new EventEmitter<void>();
  constructor(private dialogRef: MatDialogRef<FbRedirectPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    console.log(this.data.displayMessageAction, 'displayMessageAction');  
  }

  onConfirm(action: any) {
    this.confirmAction.emit(action.redirectBtnName);
    //this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

}
